<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
    <div
      class="ui basic vertical segment"
    >
      <h3 class="ui primary header sub-header">Upload File here</h3>
      <div>
        <span class="description">Only .mov, .mp4, .pdf, .doc, .ppt,  .jpg and .png files.</span>
      </div>

    <input
        #uploader type="file" style="display: none;"
        (change)="filesAttached($event)"
        multiple
        [accept]="getAllowedFormats()"
    >

      <div class="document-box">
        <div class="document-file">
          <span class="icon"></span>
          <div class="document-name">Upload File</div>
        </div>
        <button class="ui primary button" (click)="uploader.click()">
          Browse
        </button>

        <!-- <input
          hidden
          type="file"
          accept=".jpg, .jpeg, .png, .pdf,.xlsx,.docx,.ppt,.doc,.mp4,.mov"
          #uploader
          (change)="uploadDoc($event.target.files)"
          placeholder="Browse for documents"
          onclick="value = null"
        /> -->
      </div>

      <ng-container  *ngFor="let file of selectedFiles; let i = index">
        <p *ngIf="hasDocumentTitle" class="prompt" appMargin marginT="10px">
            {{documentTitles && documentTitles.length > i ? documentTitles[i] : defaultTitle}}
        </p>
        <div appMargin marginT="10px" class="file">
            <div class="first">
                <i class="file alternate outline icon"></i>
                <span>{{file?.name}}</span>
            </div>
            <div class="buttons">
                <ng-container *ngIf="file?.size < sizeLimit">
                    <i
                        suiPopup
                        popupText="View File"
                        style="cursor: pointer;"
                        class="eye outline icon"
                        (click)="viewFile(file)"
                    ></i>
                    <i
                        suiPopup
                        popupText="Remove File"
                        style="cursor: pointer; color: red"
                        class="red alternate trash icon"
                        (click)="removeFile(i)"
                    ></i>
                </ng-container>
                <i
                    *ngIf="file?.size > sizeLimit"
                    suiPopup
                    popupText="Remove File"
                    class="close icon"
                    style="cursor: pointer;"
                    (click)="removeFile(i)"
                ></i>
            </div>
        </div>
        <small *ngIf="file?.size > sizeLimit" class="error-text">File exceeds the size limit</small>
    </ng-container>
    </div>

  <div class="actions" style="border: none">
    <button class="ui primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
  </div>
</div>
